import styled from 'styled-components';

import { Link } from '../Link/Link';

export const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f4f8;

  @media (width < 1024px) {
  }

  @media (width >= 1024px) {
    padding: 88px 32px;
  }

  @media (width >= 1440px) {
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media (width < 1024px) {
    flex-direction: column;
    gap: 24px;
    padding: 32px 14px;
    text-align: center;
  }

  @media (width >= 1024px) {
    justify-content: center;
    gap: 64px;
    max-width: 1320px;
  }
`;

export const Title = styled.h2`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;

  @media (width >= 1024px) and (width < 1280px) {
    width: 200px;
  }
`;

export const CardsGrid = styled.div`
  gap: 24px;

  @media (width < 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media (width >= 768px) {
    display: flex;
    align-items: flex-start;
  }

  @media (width >= 1440px) {
  }
`;

export const Card = styled(Link)`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  width: 100%;
  max-width: 150px;
  text-align: center;
`;

export const CardCorner = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
`;

export const CardTitle = styled.h5`
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  /* text-transform: uppercase; */
`;

export const StyledLink = styled.span`
  margin-top: -8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;
